import { Component, inject } from '@angular/core';
import { OrderReadyForPickupModalComponent } from '../order-ready-for-pickup-modal/order-ready-for-pickup-modal.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'bt-order-progress-modal',
	standalone: false,
	templateUrl: './order-progress-modal.component.html',
	styleUrl: './order-progress-modal.component.scss'
})
export class OrderProgressModalComponent {
	data = inject<any>(MAT_DIALOG_DATA);
	loading = false;
	isDragging = false;

	constructor(private dialogRef: MatDialogRef<OrderProgressModalComponent>) {}

	close(): void {
		this.dialogRef.close();
	}
}
